import { createFileRoute } from "@tanstack/react-router";
import {
  SpringsLandingPage,
  buildSpringsLandingHead,
} from "@/components/SpringsLandingPage";
import { getSpringsLandingConfig } from "@/lib/springsLandingData";

const CONFIG = getSpringsLandingConfig("colorado-springs-seo-black-forest");

export const Route = createFileRoute("/colorado-springs-seo-black-forest")({
  head: () => buildSpringsLandingHead(CONFIG),
  component: () => <SpringsLandingPage config={CONFIG} />,
});
